import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Totals, StyledPrice, CartLine } from "@arcteryx/components-cart";
import TaxList from "./TaxList";
import { Body4, Body6, TextAlignment } from "@arcteryx/components-typography";

const CartLineTotal = styled(CartLine)`
  font-weight: 700;
  text-decoration: uppercase;
`;
const OrderHistoryDetails = ({ subTotal, currency, taxes, total, taxPercentage }) => {
  const { t } = useTranslation("components-order-history");

  return (
    <Totals>
      <CartLine>
        <Body6 alignment={TextAlignment.INHERIT} tag="label">{t("Subtotal")}:</Body6>
        <Body4><StyledPrice className="qa-order-total" price={subTotal} currency={currency} /></Body4>
      </CartLine>
      <TaxList taxes={taxes} />
      <CartLineTotal>
        <Body6 alignment={TextAlignment.INHERIT} tag="label">{t("Total")}:</Body6>
        {taxPercentage}
        <Body6><StyledPrice className="qa-order-item-total" price={total} currency={currency} $isBoldTotal={true} /></Body6>
      </CartLineTotal>
    </Totals>
  );
};

export default OrderHistoryDetails;
